<template>
  <div class="w-full pb-8" :class="island.isCompleted || island.isLocked ? 'py-8' : ''">
    <div v-if="island.isCompleted" class="flex flex-col gap-8 items-center px-4">
      <div
        class="relative flex flex-col justify-center items-center bg-NAVY-BLUE p-12 rounded-xl h-full"
      >
        <font-awesome-icon class="white-icon w-12 h-12" icon="fa-solid fa-check" />
      </div>
      <div class="flex flex-col">
        <p class="text-lg font-semibold pt-6">Island Completed</p>
        <p class="text-sm font-normal pt-3">
          You’ve completed <span class="font-semibold">{{ island.name }}</span
          >, and unlocked new island
        </p>
      </div>
      <div class="flex items-center gap-4 flex-wrap w-full">
        <div
          class="w-1/2-gap-4 bg-PRIMARY rounded-2xl flex flex-col gap-3 items-start justify-center p-3"
        >
          <p class="text-white font-semibold text-2xl leading-7">10</p>
          <p class="text-GREY text-xs font-semibold">Total Challenge</p>
        </div>
        <div
          class="w-1/2-gap-4 bg-PRIMARY rounded-2xl flex flex-col gap-3 items-start justify-center p-3"
        >
          <p class="text-white font-semibold text-2xl leading-7">10000</p>
          <p class="text-GREY text-xs font-semibold">Total Tokens Earned</p>
        </div>
      </div>
      <pow-button secondary class="w-full" @click="closeBottomDrawer"> Close </pow-button>
    </div>
    <div v-else-if="island.isLocked" class="flex flex-col gap-8 items-center px-4">
      <div
        class="relative flex flex-col justify-center items-center bg-NAVY-BLUE p-12 rounded-xl h-full"
      >
        <font-awesome-icon class="white-icon w-12 h-12" icon="fa-solid fa-lock" />
      </div>
      <div class="flex flex-col">
        <p class="text-lg font-semibold pt-6">Island Locked</p>
        <p class="text-sm font-normal pt-3">
          <span class="font-semibold">{{ island.name }}</span> is currently locked, finish the tasks
          on the previous islands to unlock this island
        </p>
      </div>

      <pow-button secondary class="w-full" @click="closeBottomDrawer"> Close </pow-button>
    </div>
    <div v-else class="flex flex-col items-start justify-start w-full p-4">
      <div class="flex flex-row items-center justify- gap-4 w-full">
        <div class="bg-NAVY-BLUE rounded-md p-1 h-12 w-12">
          <img :src="getImage(island)" class="w-full h-full object-contain" />
        </div>
        <div class="flex flex-col items-start justify-start w-full">
          <p class="font-semibold text-xl">{{ island.name }}</p>
        </div>
      </div>
      <div class="w-full border-t border-WHITE my-3"></div>
      <p class="text-sm font-semibold">Challange List</p>
      <div class="flex flex-col gap-2 w-full pt-3">
        <island-task-item
          v-for="(task, index) in island.tasks"
          :key="index"
          @itemClick="openRewardDrawer(task)"
          :task="task"
        >
        </island-task-item>
        <!-- Youtube
        twitter
        TELEGRAM
        arkadaş takibi
        other -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { closeBottomDrawer, openBottomDrawer } from '@/composables/bottomdrawer'
import RewardDrawer from './RewardDrawer.vue'
import PowButton from '../PowButton.vue'
import IslandTaskItem from '../IslandTaskItem.vue'

const props = defineProps({
  island: {
    type: Object,
    default: () => {}
  }
})

const getImage = (item) => {
  console.log(item)
  const index = parseInt(item.image) + 1
  var imageUrl
  if (item.isCompleted) {
    imageUrl = new URL(
      `../../assets/images/journey/journey-island-${index}-completed.svg`,
      import.meta.url
    ).href
  } else if (item.isLocked) {
    imageUrl = new URL(
      `../../assets/images/journey/journey-island-${index}-locked.svg`,
      import.meta.url
    ).href
  } else {
    imageUrl = new URL(`../../assets/images/journey/journey-island-${index}.svg`, import.meta.url)
      .href
  }
  return imageUrl
}

const openRewardDrawer = (task) => {
  var itemInfoData = {
    title: task.name,
    icon:
      task.icon === 'youtube'
        ? 'fa-brands fa-youtube'
        : task.icon === 'twitter'
          ? 'fa-brands fa-x-twitter'
          : task.icon === 'telegram'
            ? 'fa-brands fa-telegram'
            : task.icon === 'share'
              ? 'fa-solid fa-user-astronaut'
              : 'fa-solid fa-skull',
    content: task.description,
    amount: task.earning_token,
    state: 'start'
  }
  openBottomDrawer(RewardDrawer, {
    props: { itemInfo: itemInfoData },
    emits: {
      start: () => {
        console.log('start emit from reward drawer')
      }
    }
  })
}
</script>

<style lang="scss" scoped></style>
